export default {
  labelLock: {
    id: 'product_page_carriers_lock',
    defaultMessage: 'Only compatible with',
  },
  blogLink: {
    id: 'product_page_carriers_blog',
    defaultMessage: "Don't see your carrier?",
  },
  workWithAllWrapper: {
    id: 'product_page_carriers_works_with_all',
    defaultMessage: 'Works with {text, html}',
  },
  workWithAllInner: {
    id: 'product_page_carriers_works_with_all_carriers',
    defaultMessage: 'all carriers',
  },
}
